"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lib = require("react-bootstrap/lib");
require("./EllipsedPagination.scss");
/*
This is existing logic in the old version of the styleguide,
the requirements are paging are not document so just re-using the existing logic
*/
var getWindows = function getWindows(pageIndex, pageCount) {
  var innerWindow = 1;
  var outerWindow = 4;
  var currentPage = pageIndex + 1;
  var windowFrom = currentPage - innerWindow;
  var windowTo = currentPage + innerWindow;
  var left = [];
  var middle = [];
  var right = [];
  var i;

  // adjust lower or upper limit if other is out of bounds
  if (windowTo > pageCount) {
    windowFrom -= windowTo - pageCount;
    windowTo = pageCount;
  }
  if (windowFrom < 1) {
    windowTo += 1 - windowFrom;
    windowFrom = 1;
    if (windowTo > pageCount) {
      windowTo = pageCount - 1;
    }
  }

  // these are always visible
  for (i = windowFrom; i <= windowTo; i += 1) {
    middle.push(i);
  }

  // left window
  var middleFirst = middle[0];
  if (outerWindow + 3 <= middleFirst) {
    for (i = 1; i <= outerWindow + 1; i += 1) {
      left.push(i);
    }
    left.push('gap');
  } else {
    for (i = 1; i < middleFirst; i += 1) {
      left.push(i);
    }
  }

  // right window
  var middleLast = middle[middle.length - 1];
  if (pageCount - outerWindow - 2 > middleLast) {
    for (i = pageCount - outerWindow; i <= pageCount; i += 1) {
      right.push(i);
    }
    right.unshift('gap');
  } else {
    for (i = middleLast + 1; i <= pageCount; i += 1) {
      right.push(i);
    }
  }
  return (0, _concat["default"])(left).call(left, middle, right);
};
var EllipsedPagination = function EllipsedPagination(_ref) {
  var _context;
  var pageCount = _ref.pageCount,
    pageIndex = _ref.pageIndex,
    onChange = _ref.onChange,
    PaginationItem = _ref.PaginationItem,
    PrevButton = _ref.PrevButton,
    NextButton = _ref.NextButton;
  return /*#__PURE__*/_react["default"].createElement(_lib.Row, {
    style: {
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Col, {
    xs: 1,
    sm: 2
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "pager"
  }, /*#__PURE__*/_react["default"].createElement(PrevButton, {
    onChange: onChange,
    pageCount: pageCount,
    pageIndex: pageIndex
  }))), /*#__PURE__*/_react["default"].createElement(_lib.Col, {
    xs: 10,
    sm: 8,
    style: {
      textAlign: 'center'
    }
  }, /*#__PURE__*/_react["default"].createElement(_lib.Pagination, null, (0, _map["default"])(_context = getWindows(pageIndex, pageCount)).call(_context, function (pageNumber) {
    return pageNumber === 'gap' ? /*#__PURE__*/_react["default"].createElement(_lib.Pagination.Ellipsis, {
      key: pageNumber,
      className: "disabled"
    }) : /*#__PURE__*/_react["default"].createElement(_lib.Pagination.Item, {
      key: pageNumber,
      active: pageNumber === pageIndex + 1,
      onClick: function onClick() {
        return onChange(pageNumber - 1);
      }
    }, /*#__PURE__*/_react["default"].createElement(PaginationItem, {
      pageNumber: pageNumber
    }));
  }))), /*#__PURE__*/_react["default"].createElement(_lib.Col, {
    xs: 1,
    sm: 2
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "pager"
  }, /*#__PURE__*/_react["default"].createElement(NextButton, {
    onChange: onChange,
    pageCount: pageCount,
    pageIndex: pageIndex
  }))));
};
var PreviousButton = function PreviousButton(_ref2) {
  var pageIndex = _ref2.pageIndex,
    onChange = _ref2.onChange;
  return /*#__PURE__*/_react["default"].createElement(_lib.Pager.Item, {
    previous: true,
    disabled: pageIndex === 0,
    onClick: function onClick() {
      return onChange(pageIndex - 1);
    },
    className: "ellipsed-pagination-button"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-left"
  }), "Prev");
};
var ForwardButton = function ForwardButton(_ref3) {
  var pageIndex = _ref3.pageIndex,
    pageCount = _ref3.pageCount,
    onChange = _ref3.onChange;
  return /*#__PURE__*/_react["default"].createElement(_lib.Pager.Item, {
    next: true,
    disabled: pageCount - 1 === pageIndex,
    onClick: function onClick() {
      return onChange(pageIndex + 1);
    },
    className: "ellipsed-pagination-button"
  }, "Next", /*#__PURE__*/_react["default"].createElement("i", {
    className: "icon icon-right"
  }));
};
PreviousButton.propTypes = {
  pageIndex: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
ForwardButton.propTypes = {
  pageIndex: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func.isRequired,
  pageCount: _propTypes["default"].number.isRequired
};
EllipsedPagination.defaultProps = {
  onChange: function onChange() {},
  PaginationItem: function PaginationItem(_ref4) {
    var pageNumber = _ref4.pageNumber;
    return pageNumber;
  },
  PrevButton: PreviousButton,
  NextButton: ForwardButton
};
EllipsedPagination.propTypes = {
  pageCount: _propTypes["default"].number.isRequired,
  pageIndex: _propTypes["default"].number.isRequired,
  onChange: _propTypes["default"].func,
  PaginationItem: _propTypes["default"].elementType,
  PrevButton: _propTypes["default"].elementType,
  NextButton: _propTypes["default"].elementType
};
var _default = exports["default"] = EllipsedPagination;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/lib/EllipsedPagination.js
// module id = 433
// module chunks = 25